<template>
    <div id="tools-box" :class="[$mq, 'overlay']" @click.self="closeBox">
        <div class="menu">
            <!-- USER INFO -->
            <div class="location-info">
                <div class="name">{{ locationData.name }}</div>
            </div>
            <!-- USER ACTIONS -->
            <div class="tools hide-scrollbar">
                <!-- RENEW WARN -->
                <li class="tool" id="navRenew" key="main_tools_renew" v-if="renewLicense" @click="openRenewPopup">
                    <div class="icon"></div>
                    <span class="text" v-html="$t('menu_tools.renew_title')"></span>
                </li>
                <!-- ALERTS WARN -->
                <li class="tool" id="navAlerts" key="main_tools_alerts" v-if="withAlerts" @click="openAlertsView">
                    <i class="i-andy-exclamation i-andy-ml"></i>
                    <span class="text" v-html="$t('menu_tools.alerts_title')"></span>
                </li>

                <!-- HOME TOOL -->
                <div class="tool" v-if="!showRadarAsHome" :class="{ selected: location.indexOf('home') > -1 }" id="navHome" @click="navTool('/')">
                    <div class="icon"></div>
                    <div class="text">{{ $t('tools.home_title') }}</div>
                </div>

                <!-- ANDY TOOLS -->
                <template v-for="(tool, i) in tools">
                    <div class="tool tool-item" :class="{ selected: location.indexOf(tool.action) > -1 }" :id="tool.id" v-if="isMenuToolVisible(tool)" @click="navTool(tool.action)" :key="'main_tools' + i">
                        <div class="menu-tool-icon-wrapper">
                            <i v-if="tool.icon" class="i-andy-l menu-tool-icon" :class="tool.icon"></i>
                            <span v-if="isRadarTool(tool) && hasRadarContent" class="radar-notification-badge"></span>
                        </div>
                        <div class="text">{{ $t(tool.name) }}</div>
                    </div>
                </template>


                <!-- EXTERNAL TOOLS -->
                <template v-for="(tool, i) in Object.values(external_tools)">
                    <div class="tool" :class="{ selected: location.indexOf(tool.action) > -1 }" v-if="tool.type && tool.type != 'intent'" @click="navToolExternal(tool)" :key="'external_tools' + i">
                        <div class="icon" :style="{ backgroundImage: 'url(' + iconTool(tool) + ')' }"></div>
                        <div class="text">{{ $t(tool.name) }}</div>
                    </div>
                </template>

                <!-- CONFIG TOOL -->
                <div class="submenu-tool" v-if="settingsAvailable">
                    <div class="tool" :class="{ selected: location.indexOf('config') > -1 }" id="navConfig" @click="navTool('/config/location', 'config')">
                        <div class="icon"></div>
                        <div class="text">{{ $t('menu_tools.config_title') }}</div>
                    </div>
                    <div class="subtools" :class="{ visible: location.indexOf('config') > -1 || submenuExpand.config }">
                        <div class="subtool" @click="navTool('/config/location')" :class="{ selected: $route.path == '/config/location' }">
                            <div class="text">{{ $t('config.location.title') }}</div>
                        </div>
                        <div v-if="canAccessTemplates" class="subtool" @click="navTool('/config/templates')" :class="{ selected: $route.path == '/config/templates' }">
                            <div class="text">{{ $t('config.templates.title') }}</div>
                        </div>
                        <div class="subtool" v-if="visibleTools.includes(3)" @click="navTool('/config/printer')" :class="{ selected: $route.path == '/config/printer' }">
                            <div class="text">{{ $t('config.printer.title') }}</div>
                        </div>
                        <div class="subtool" v-if="hasSensorTool && userRole >= 3" @click="navTool('/config/sensconfig')" :class="{ selected: $route.path == '/config/sensconfig' }">
                            <div class="text">{{ $t('config.sensor.title') }}</div>
                        </div>
                        <div class="subtool" @click="navTool('/config/dashboard')" v-if="!auditor" :class="{ selected: $route.path == '/config/dashboard' }">
                            <div class="text">{{ $t('config.dashboard.title') }}</div>
                        </div>
                        <div v-if="canCreateUsers && !auditor" class="subtool" @click="navTool('/config/users')" :class="{ selected: $route.path == '/config/users' }">
                            <div class="text">{{ $t('config.users.title') }}</div>
                        </div>
                        <div class="subtool" @click="navTool('/config/status')" :class="{ selected: $route.path == '/config/status' }">
                            <div class="text">{{ $t('config.status.title') }}</div>
                        </div>
                    </div>
                </div>

                <!-- HELP TOOL -->
                <div class="tool" :class="{ selected: location.indexOf('tickets') > -1 }" id="navHelp" @click="navTool('/tickets')">
                    <div class="icon"></div>
                    <div class="text">{{ $t('menu_tools.tickets') }}</div>
                </div>
            </div>

            <div class="version">{{ $t('tooltip.version') }}: {{ appVersion }}</div>
        </div>
    </div>
</template>

<script>
import employee from '@/components/domain/login/employee'

export default {
    components: { employee },
    data() {
        return {
            submenuExpand: { config: false }
        }
    },
    computed: {
        isAuditorLogin() {
            return (this.$store.getters.isAuditorLogin || this.$store.getters['loginUser/getAuditor']) && this.$route.name !== 'Login'
        },
        showRadarAsHome() {
            return this.$store.getters['getShowRadarAsHome']
        },
        locationData() {
            return this.$store.getters['loginUser/getLocalLocation']
        },
        settingsAvailable() {
            return this.$store.getters.getSettingsAvailable
        },
        emp_id() {
            return this.$store.getters['loginUser/getLocalEmployee']
        },
        releases() {
            return this.$store.getters['login/getAllReleases']()
        },
        auditor() {
            return this.$store.getters['loginUser/getAuditor']
        },

        // user() {
        //     var employee = this.$store.getters['employee/getEmployee'](this.emp_id)

        //     if (employee) {
        //         return employee
        //     }
        // }
        userRole() {
            var user = this.$store.getters['employee/getEmployee'](this.emp_id)
            var roles = this.$store.getters['employee/getAllRoles']
            if (user && Object.keys(roles).length > 0) {
                return parseInt(roles[user.rol].level)
            }
        },
        location() {
            return this.$route.path
        },
        showRadarTool() {
            return this.$store.getters['getShowRadarTool']
        },
        hasRadarContent() {
            return this.$store.getters['radar/getHasRadarContent']
        },
        appVersion() {
            return process.env.VUE_APP_VERSION ? process.env.VUE_APP_VERSION : ''
        },
        // TOOLS COMPUTED
        tools() {
            var tools = this.$store.getters['getMenuToolsByRoleLevel'](this.userRole)
            log(tools)
            const aTools = this.$store.getters['sortToolsForSidebar'](tools)

            var self = this
            self.alexTools = 0
            aTools.forEach((tool) => {
                if (self.isMenuToolVisible(tool)) self.alexTools++
            })

            log(aTools, this.visibleTools)
            return aTools
        },
        hasSensorTool() {
            let tools = this.$store.getters['login/getConfig'].tools
            //if tools has number 13 then return true
            return tools.includes(13)
        },

        external_tools() {
            var tools = this.$store.getters['getMenuToolsByRoleLevel'](this.userRole)
            var aTools = []
            for (var k in tools) {
                var tool = tools[k]
                if (typeof tool.type !== 'undefined') aTools.push(tool)
            }
            return this.$store.getters['sortToolsForSidebar'](aTools)
        },

        visibleTools() {
            var visible = []
            const config = this.$store.getters['login/getConfig']
            if (config && config.tools) {
                config.tools.forEach((tool) => {
                    const code = Number(tool)
                    if (![8, 9].includes(code)) {
                        visible.push(code)
                    }
                })
            }

            return visible
        },
        canCreateUsers() {
            return parseInt(this.$store.getters.getCanCreateUsers)
        },
        canAccessTemplates() {
            return this.$store.getters.getCanAccessTemplatesMenu
        },
        renewLicense() {
            return this.$store.getters['getLicenseEndDate']
        },
        isLicenseExpired() {
            if (!this.renewLicense) return false
            const now = moment()
            const licenseEndDate = moment(this.renewLicense)
            return now.isSameOrAfter(licenseEndDate)
        },
        daysLeft() {
            const expireDate = this.renewLicense ? moment(this.renewLicense) : false

            if (!expireDate) return 0
            if (!expireDate.isValid()) return 0

            const now = moment()
            const differenceDays = expireDate.diff(now, 'days') + 1
            const resultOfDaysLeft = now.isAfter(expireDate) ? 0 : differenceDays

            return resultOfDaysLeft
        },
        withAlerts() {
            let config = this.$store.getters['login/getConfig']
            if (config && (typeof config.show_alerts == 'undefined' || !config.show_alerts)) return false
            const sensorHome = this.$store.getters['sensor/getSensorHome']
            let issues = this.$store.getters['getAlertsActive']
            let alerts = sensorHome.alerts
            let inactive = sensorHome.inactive
            let turnedOff = sensorHome.turned_off
            let active = alerts > 0 || inactive > 0 || turnedOff > 0
            for (var key in issues) {
                if (!active && issues[key] > 0) active = true
            }
            return active
        }
    },
    methods: {
        openRenewPopup() {
            if (this.isLicenseExpired) {
                return
            }
            this.$store.commit('setMenuToolsExpanded', false)
            this.$store.commit('setSubMenuToolsExpanded', false)
            this.$store.commit('setMenuUserVisible', false)

            const self = this
            this.$popup.renew({
                message: this.$t('popup.renew.message', { days: self.daysLeft })
            })
        },
        openAlertsView() {
            let self = this
            const alertsPath = '/alerts'

            if (self.$route.path === alertsPath) {
                self.closeBox()
                return
            }

            self.$router.push(alertsPath).catch((err) => {
                if (err && err.name == 'NavigationDuplicated') {
                    self.$router.push('/reset' + alertsPath)
                }
            })
        },
        isRadarTool(tool) {
            return tool.id === 'navRadar'
        },
        isMenuToolVisible(tool) {
            if (tool.type) {
                return false
            }

            if (this.isRadarTool(tool)) {
                return this.showRadarTool
            }

            return this.visibleTools.indexOf(Number(tool.code)) !== -1
        },
        // TOOL ACTIONS
        navTool(action, subtool = false) {
            if (action.indexOf('/config') === 0 && !this.settingsAvailable) return

            if (subtool) {
                this.submenuExpand[subtool] = !this.submenuExpand[subtool]
            } else {
                let self = this
                if (self.$store.getters['hasAccess'](self.currentEmployee().id, 0) || action == '/config/location' || action == '/release') {
                    const target = self.redirectPath(action)

                    if (self.$route.path === target) {
                        self.closeBox()
                        return
                    }

                    if (self.isAuditorLogin && target === '/' && self.$route.path !== '/audit') {
                        self.$router.push('/audit')
                        return
                    }

                    self.$router.push(target).catch((err) => {
                        if (err && err.name == 'NavigationDuplicated') {
                            self.$router.push('/reset' + target)
                        }
                    })
                } else {
                    const isKitchenModeOn = self.$store.getters.isKitchenModeActive
                    const kitchenHomeRoutes = ['/', '/home', '/chat', '/homewidgets']

                    if (isKitchenModeOn && !self.emp_id && kitchenHomeRoutes.includes(action)) {
                        if (self.$route.path !== '/homewidgets') {
                            self.$router.push('/homewidgets')
                        } else {
                            self.closeBox()
                        }
                    } else {
                        const allowedRoutes = ['/traceability', '/timers', '/library', '/allergens', '/sensor', '/pls', '/homewidgets']

                        if (allowedRoutes.includes(action)) {
                            if (self.$route.path !== action) {
                                self.$router.push(action)
                            } else {
                                self.closeBox()
                            }
                        } else {
                            this.$popup.login({
                                list: this.$store.getters['employee/getLoginUsers'](0),
                                callAfterAccess: function (response) {
                                    if (response) {
                                        const dest = self.redirectPath(action)
                                        if (self.$route.path !== dest) {
                                            self.$router.push(dest).catch((err) => {
                                                if (err && err.name == 'NavigationDuplicated') {
                                                    self.$router.go(self.$router.history.current)
                                                }
                                            })
                                        }
                                        self.$popup.close()
                                    }
                                }
                            })
                        }
                    }
                }
            }
        },
        navToolExternal(tool) {
            if (tool.type == 'url') {
                var hyperlink = tool.action.startsWith('www') ? 'https://' + tool.action : tool.action
                window.open(hyperlink, '_blank')
            } else if (this.isAPP) {
                window.plugins.launcher.canLaunch(
                    { packageName: tool.action },
                    function () {
                        window.plugins.launcher.launch(
                            { packageName: tool.action },
                            function () {
                                log('INTENT LANZADO')
                            },
                            function () {}
                        )
                    },
                    function () {}
                )
            } else {
                log('TODO nada para poder hacer mostrar alerta?')
            }
        },

        iconTool(tool) {
            return tool.icon
        },

        // GENERAL METHODS
        closeBox() {
            this.$store.commit('setMenuToolsExpanded', false)
        },

        currentEmployee() {
            var emp_id = this.$store.getters['loginUser/getLocalEmployee']

            if (emp_id) {
                var emp = this.$store.getters['employee/getEmployee'](emp_id)
            } else {
                var emp = this.$store.getters['loginUser/getLocalLocation']
            }

            return emp
        },

        redirectPath(firstResult) {
            return this.$root.redirectPath(firstResult)
        },

        toCurrentRoute() {
            let currentPath = this.$route.path
            let aux = this.$route.path.split('/')[1]
            let parentPath = typeof aux !== 'undefined' ? '/' + aux : false

            if (parentPath && parentPath != currentPath) {
                this.$router.push({ path: parentPath })
            }
        }
    },
    mounted() {}
}
</script>

<!-- // PORTRAIT STYLES -->
<style lang="scss">
#tools-box.overlay.portrait {
    $menu-top-height: 60px;

    #navHome {
        .icon {
            background-image: img('menu_home_dark.svg');
        }
        &.selected {
            .icon {
                background-image: img('menu_home_light.svg');
            }
        }
    }
    #navTickets {
        .icon {
            background-image: img('menu_support_dark.svg');
        }
        &.selected {
            .icon {
                background-image: img('menu_support_light.svg');
            }
        }
    }

    #navRelease {
        .icon {
            background-image: img('menu_release_dark.svg');
        }

        &.selected {
            .icon {
                background-image: img('menu_release_light.svg');
            }
        }
    }

    #navAlerts {
        display: flex !important;
        flex-direction: row;
        gap: 5px;
        background-color: $error-light;

        i {
            color: $error-dark;
        }

        .text {
            color: $color-black;
        }
    }

    #navConfig {
        .icon {
            background-image: img('menu_config_dark.svg');
        }
        &.selected {
            .icon {
                background-image: img('menu_config_light.svg');
            }
        }
    }

    #navRenew {
        .icon {
            background-image: img('renew.svg');
        }
        &.selected {
            .icon {
                background-image: img('renew.svg');
            }
        }
    }

    #navHelp {
        .icon {
            background-size: 30px;
            background-image: img('menu_help.svg');
        }
        &.selected {
            .icon {
                background-image: img('info_main_light.svg');
                background-size: 25px;
            }
        }
    }

    background-color: transparent;
    z-index: 19000000;
    height: calc(100%);
    width: 100vw;
    position: absolute;
    top: $menu-top-height;
    top: 0;
    left: 0;

    .menu {
        $menu-top-height: 60px;
        width: 90%;
        height: calc(100% - #{$menu-top-height} + 1px);
        background-color: $default-bg-color;
        position: absolute;
        left: 0;
        top: 59px;
        max-width: 400px;
        z-index: 2000000;
        padding: 15px;

        .location-info {
            @include display-flex();
            @include align-items();
            height: 50px;
            margin-bottom: 10px;

            .name {
                @include background($size: 19px, $image: img('location_inactive-s70.svg'), $position: left 8px center);
                @include font-size(xs);
                @include text-ellipsis();
                padding-left: 30px;
                color: $inactive-s70;
                display: inline-block;
                width: fit-content;
                font-family: $text-bold;
                height: rem(30px);
                // line-height: rem(30px);
                line-height: 40px;
                max-width: 100%;
            }
        }

        .tools {
            // display: grid;
            // grid-template-columns: 1fr;
            // grid-template-rows: auto;
            // grid-gap: 15px;
            // align-items: start;
            // align-content: start;
            // justify-items: center;
            // justify-content: center;
            @include display-flex();
            @include align-items();
            @include flex-direction(column);
            width: 100%;
            height: calc(100% - 60px - 30px - 10px);
            padding: 0px;
            // padding-bottom: 30px;
            overflow: auto;
            margin-bottom: 10px;
            max-width: 100%;

            .tool {
                @include border-radius(5px);
                @include display-flex();
                @include align-items();
                $action-height: 50px;
                background-color: #fff;
                width: 100%;
                height: $action-height;
                min-height: $action-height;
                padding: 10px;
                cursor: pointer;
                margin-bottom: 10px;

                .icon {
                    width: 30px;
                    height: 100%;
                    // @include background($position: left center, $size: 30px);
                    background-position: center center;
                    background-size: 30px;
                    background-repeat: no-repeat;
                }

                .menu-tool-icon-wrapper {
                    position: relative;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    width: 36px;
                    height: 36px;
                }

                .menu-tool-icon {
                    @include display-flex();
                    @include align-items();
                    @include justify-content(center);
                    width: 36px;
                    height: 36px;
                    flex-shrink: 0;
                    color: #b5b2ab;
                }

                .radar-notification-badge {
                    position: absolute;
                    top: 5.947px;
                    right: -3px;
                    width: 12px;
                    height: 12px;
                    border-radius: 32px;
                    background-color: $error-dark;
                    pointer-events: none;
                }

                .text {
                    @include text-ellipsis();
                    width: calc(100% - 30px);
                    line-height: $action-height;
                    font-family: $text-bold;
                    padding-left: 10px;
                    max-width: 100%;
                }

                &.selected {
                    background-color: $main;
                    .text {
                        color: #fff;
                    }

                    .menu-tool-icon {
                        color: $color-white;
                    }
                }

                &.profile {
                    .icon {
                        @include background($image: img('user_cccccc.svg'), $position: left center, $size: 25px);
                    }
                }
                &.logout {
                    .icon {
                        @include background($image: img('logout_main_t20.svg'), $position: left center, $size: 25px);
                    }
                }
            }

            .submenu-tool {
                width: 100%;

                .tool {
                    // margin-bottom: 5px;
                    .text {
                        padding-right: 20px;
                        @include background($image: img('down_caret_dark.svg'), $position: right center, $size: 10px);
                        -webkit-appearance: none;
                        -moz-appearance: none;
                    }
                    &.selected {
                        .text {
                            @include background($image: img('up_caret_light.svg'), $position: right center, $size: 10px);
                        }
                    }
                }

                .subtools {
                    display: grid;
                    grid-template-columns: 1fr;
                    grid-template-rows: auto;
                    grid-gap: 5px;
                    align-items: start;
                    align-content: start;
                    justify-items: center;
                    justify-content: center;
                    width: 100%;
                    padding: 0px;
                    // padding-bottom: 30px;
                    overflow: hidden;
                    max-height: 0;
                    margin-bottom: 0;
                    transition: 0.2s;

                    &.visible {
                        max-height: 100vh;
                        margin-bottom: 10px;
                    }

                    .subtool {
                        @include border-radius(5px);
                        @include display-flex();
                        @include align-items();
                        $action-height: 50px;
                        background-color: rgba(255, 255, 255, 0.6);
                        width: 100%;
                        height: $action-height;
                        padding: 10px;
                        cursor: pointer;

                        .text {
                            padding-left: 15px;
                            color: $neutro-s60 !important;
                            font-family: $text-bold;
                        }

                        &.selected {
                            background-color: $neutro;
                            .text {
                                color: $main !important;
                            }
                        }
                    }
                }
            }
        }

        .version {
            @include display-flex();
            @include align-items(flex-end);
            @include justify-content(flex-end);
            @include font-size(xs);
            color: $neutro-s50;
            width: 100%;
            height: 30px;
            text-align: right;
        }
    }
}
#tools-box .menu-tool-icon.i-andy-menu-label {
    width: 36px;
    height: 36px;
    background-image: img('menu_label_dark.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    font-size: 0;

    &::before {
        content: none;
    }
}

#tools-box .tool.selected .menu-tool-icon.i-andy-menu-label {
    background-image: img('menu_label_light.svg');
}
</style>
